import { useEffect, useState } from 'react';

import { isCanonicalProduct } from '../../../../shared/utils/product/product';

function useCanonicalDefaultProduct(product) {
  const isCanonical = isCanonicalProduct(product);
  const [canonicalProductCode, setCanonicalProductCode] = useState(
    isCanonical ? product.code : null
  );
  const [shouldIgnoreDefaultProduct, setShouldIgnoreDefaultProduct] = useState(
    !isCanonical
  );

  const productCode = product?.code;

  useEffect(() => {
    if (isCanonical && canonicalProductCode !== productCode) {
      setCanonicalProductCode(productCode);
      setShouldIgnoreDefaultProduct(false);
    } else if (!isCanonical) {
      setShouldIgnoreDefaultProduct(true);
    }
  }, [isCanonical, canonicalProductCode, productCode]);

  return {
    shouldIgnoreDefaultProduct
  };
}

export default useCanonicalDefaultProduct;
